// export default SignUpForm;
import React, { useEffect, useState, useRef } from "react";
import classes from "../Login.module.scss";
import RoundedButton from "../../Buttons/RoundedButton";
// import InfoLabel from "../../InfosLabels/InfosPasswordLabels/InfoLabel";
import TagInput from "../../UI/Inputs/TagInput";
import H1 from "../../UI/Titles/H1/h1";
import { useTranslation } from "react-i18next";
import {
  CUSTOM_BIRTH_DATE,
  CUSTOM_INVITE_CODE,
  CUSTOM_OCCUPATION,
} from "../../../constants/users_login";
import InfosPasswordLabels from "../../InfosLabels/InfosPasswordLabels";
import InfoLabel from "../../InfosLabels/InfoLabel";
import Spinner from "../../UI/Spinner";
import Select from "../../UI/Select/Select";
import Checkbox from "../../UI/Checkbox/Checkbox";
import * as kApi from "../../../constants/api";
import { checkPasswordValidations } from "../../../helpers";
import { PROD } from "../../../constants/defaults";
import axios from "../../../axios/axios";
import { API_URL_STATIC_OPTIONS } from "../../../constants/api";
import ReCAPTCHA from "react-google-recaptcha";
import { Auth } from "aws-amplify";

const SignUpForm = ({
  login = {},
  showCode = true,
  errorMsg = null,
  errorObject={},
  suggestedEmail="",
  formSubmit = () => { },
  onChange = () => { },
  onBlur = () => { },
}) => {
  const { t } = useTranslation();
  const [hasRead, setHasRead] = useState();
  const [activeButton, setActiveButton] = useState(true);
  const [options, setOptions] = useState(null);
  const [pw, setPW] = useState("");
  const recaptchaRef = useRef(null);


  const {
    hasLowercase,
    hasUppercase,
    hasNumber,
    hasMinEight,
  } = checkPasswordValidations(pw);

  const isProd = kApi.GET_PROD_OR_DEV === PROD;

  //Scroll to top when start
  useEffect(() => window.scrollTo(0, 200), []);




  useEffect(() => {
    if (!options) {
      axios
        .get(API_URL_STATIC_OPTIONS)
        .then((res) => setOptions(res.data))
        .catch((errors) => setOptions({}))
    }
  }, [options]);

  let optionsProf = null;
  if (options && options.professions) {
    optionsProf = options.professions.map((prof) => {
      return {
        value: prof,
        func: () =>
          onChange({
            target: {
              name: CUSTOM_OCCUPATION,
              value: prof,
            },
          }),
      };
    });
    optionsProf.unshift({
      value: "-",
      func: () =>
        onChange({
          target: {
            name: CUSTOM_OCCUPATION,
            value: "",
          },
        }),
    });
  }
  const onExpireRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e)
    recaptchaRef.current.execute();
  }
  const onErrorRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e)
    setActiveButton(true);
  }
  const onRecaptchaCorrect = (e) => {
    console.log("onRecaptchaCorrect")
    formSubmit();
  }

  return (
    <>
      <form
        className={classes.Form}
        onSubmit={(event) => {
          if (event) event.preventDefault();
          recaptchaRef.current.execute();
          setActiveButton(false);
        }}
      >
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={kApi.SECRET_reCAPTCHA}
          isolated={true}
          badge="bottomleft"
          type="image"
          onErrored={onErrorRecaptcha}
          onChange={onRecaptchaCorrect}
          onExpired={onExpireRecaptcha}
        />
        <H1 className={classes.Title}>{t("global.new_signup")}</H1>
        {errorMsg && <div className={classes.ErrorMsg}>{t(errorMsg)}</div>}
        <TagInput
          type="text"
          name="given_name"
          className={classes.Input}
          label={t("global.nickname") + "*"}
          placeholder={t("global.nickname")}
          value={login.given_name}
          onChange={onChange}
          onBlur={onBlur}
          error={(errorObject['given_name'])?errorObject['given_name']['message']:false}
          errorType={(errorObject['given_name'])?errorObject['given_name']['type']:false}
          required
        />
        <TagInput
          type="email"
          correctionSafari={true}
          name="username"
          className={classes.Input}
          label={t("global.email") + "*"}
          suggestedText={suggestedEmail}
          placeholder={t("global.email")}
          value={login.username}
          onChange={onChange}
          onBlur={onBlur}
          error={(errorObject['username'])?errorObject['username']['message']:false}
          errorType={(errorObject['username'])?errorObject['username']['type']:false}
          required
        />
        <TagInput
          type="date"
          name={CUSTOM_BIRTH_DATE}
          className={classes.Input}
          label={t("global.birthdate") + "*"}
          placeholder={t("global.birthdate")}
          value={login[CUSTOM_BIRTH_DATE]}
          onChange={onChange}
          onBlur={onBlur}
          error={(errorObject[CUSTOM_BIRTH_DATE])?errorObject[CUSTOM_BIRTH_DATE]['message']:false}
          errorType={(errorObject[CUSTOM_BIRTH_DATE])?errorObject[CUSTOM_BIRTH_DATE]['type']:false}
          required
        />
        {options && options === false && (
          <div>
            <Spinner center small />
          </div>
        )}
        {options && options.professions && optionsProf && (
          <div className={classes.SelectArea}>
            <label className={classes.Label}>{t("global.ocupation")}*</label>
            <Select className={classes.Select} options={optionsProf} />
          </div>
        )}
        <TagInput
          type="password"
          name="password"
          className={classes.Input + " " + classes.InputPassword}
          label={t("global.password") + "*"}
          placeholder={t("global.password")}
          value={login.password}
          onChange={(t) => {
            setPW(t.target.value);
            onChange(t);
          }}
          onBlur={onBlur}
          error={(errorObject['password'])?errorObject['password']['message']:false}
          errorType={(errorObject['password'])?errorObject['password']['type']:false}

          required
        />
        <InfosPasswordLabels
          hasLowercase={hasLowercase}
          hasUppercase={hasUppercase}
          hasNumber={hasNumber}
          hasMinEight={hasMinEight}
        />
        {/* {showCode && (
          <TagInput
            type="text"
            name={CUSTOM_INVITE_CODE}
            className={classes.Input}
            label={t("Possui um código de convite?")}
            placeholder={t("Campo não obrigatório")}
            value={String(login[CUSTOM_INVITE_CODE])}
            onChange={onChange}
            maxLength={8}
            required={
              login[CUSTOM_INVITE_CODE] && login[CUSTOM_INVITE_CODE].length > 0
                ? true
                : false
            }
          />
        )} */}
        {login[CUSTOM_INVITE_CODE] &&
          login[CUSTOM_INVITE_CODE].length > 0 &&
          login[CUSTOM_INVITE_CODE].length !== 8 && (
            <InfoLabel
              className={"col-12"}
              text={"*" + t("Código de convite deve ter 8 Letras")}
            />
          )}
        <Checkbox value={hasRead} onClick={() => setHasRead(!hasRead)}>
          <span onClick={() => setHasRead(true)}>
            {t("global.i_have_read_and_agree_to_the_terms") + " "}
          </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            title={t(global.use_terms)}
            href={kApi.STATIC_FILE_USE_TERMS}
          >
            <span onClick={() => setHasRead(true)}>
              {t("global.terms_of_use") + " "}
            </span>
          </a>
          <br />
          {t("global.and") + " "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            title={t(global.priv_politics)}
            href={kApi.STATIC_FILE_PRIV_POLITICS}
          >
            {t("global.terms_of_privacy")}
          </a>
        </Checkbox>
        <RoundedButton
          disable={!hasRead || Object.values(errorObject).reduce((all,cur)=>all && cur,true)}
          className={classes.BtnEnter}
          type="submit"
          text={t("global.signup")}
        />
      </form>
    </>
  );
};

export default SignUpForm;

